import API from 'src/services/api';
import { simplePage } from './simplePage';

export default simplePage(API.CONTENT.imprint());



// WEBPACK FOOTER //
// ./src/views/Imprint.tsx